import React from 'react'
import './style.css'
import RatingStar from '../../ratingStars/RatingStar'

const ShareYourExperienceBox = () => {
    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="share-your-experience-box">
                            <h1 className='home-main-heading'>Share Your Experience</h1>
                            <p className="common-text">share your lorem experience</p>

                            <p className='common-text mt-4'>Lorem ipsum dolor sit amet consectetur adipisicing elit. Exercitationem expedita perferendis magni suscipit saepe delectus quis, deserunt modi eos quod aperiam ratione, unde maxime, voluptas minus! Exercitationem quidem est assumenda.</p>

                            <p className='common-text mb-0'>HOW MUCH YOU WANT TO RATE?</p>
                            <RatingStar />
                            <form action="">
                                <p className='common-text mt-4'>WHAT's YOUR REVIEW?</p>
                                <div className="mb-3">
                                    <textarea className="form-control message-box-text" id="exampleFormControlTextarea1" rows="3"></textarea>
                                </div>

                                <div className="submit-btn-form"><button type="submit" className="btn btn-primary">Submit</button></div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ShareYourExperienceBox